export const skeletonColor = Styles.color.grey.ten;
export const skeletonSecondaryColor = Styles.color.white;

export const primarySkeletonTheme = {
  color: skeletonColor,
};

export const secondarySkeletonTheme = {
  color: skeletonSecondaryColor,
  highlightColor: skeletonColor,
};
